import { Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { db } from "astrid-firebase";
import { useCollectionData } from "astrid-firestore/src/hooks/index";

import Flex from "../../../../components/Flex/Flex";
import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import CreateExportPresetForm from "../../../exports/components/SuperAdminExportPreset/CreateExportPresetForm";
import Table from "../../../tables/components/Table";

export default function SuperAdminExportPresetsView() {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [exportPresets, loading, error] = useCollectionData(
		db.collection("exportPresets").where("deleted", "==", false),
	);

	return (
		<>
			<Flex gap={10} wrap style={{ marginBottom: 15 }}>
				<div>
					<Header as="h2">{t("exportPresets", "Export presets")}</Header>
				</div>
				<OpenButton text={t("createExportPreset", "Create export preset")}>
					{({ setOpen }) => <CreateExportPresetForm onClose={() => setOpen(false)} />}
				</OpenButton>
			</Flex>
			<LoadingContext data={exportPresets} loading={loading} error={error}>
				<Table
					data={exportPresets}
					columns={[
						{
							id: "name",
							Header: t("Name", "Name"),
						},
					]}
					onClick={({ id }) => navigate(id)}
				/>
			</LoadingContext>
		</>
	);
}
